module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }